// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.insight-header {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  align-items: center;
  margin: 8px 0 18px;
  flex-wrap: wrap;
}

.insight-greeting {
  font-size: 30px;
  font-weight: 800;
  color: #1a3483;
  letter-spacing: -0.4px;
}

.dark-theme .insight-greeting {
  color: #f8fafc;
}

.insight-refresh-btn {
  background: #1a3483 !important;
  border-color: #1a3483 !important;
  border-radius: 999px !important;
  padding: 9px 18px !important;
  font-weight: 700 !important;
}

.insight-card,
.insight-stat-card {
  border: 0;
  border-radius: 18px !important;
  box-shadow: 0 12px 30px rgba(15, 23, 42, 0.08);
  overflow: hidden;
}

.insight-stat-card .card-body {
  position: relative;
  min-height: 148px;
}

.insight-stat-icon {
  width: 42px;
  height: 42px;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(26, 52, 131, 0.1);
  color: #1a3483;
  font-size: 22px;
  margin-bottom: 12px;
}

.dark-theme .insight-stat-icon {
  background: rgba(255, 255, 255, 0.12);
  color: #fff;
}

.insight-stat-title {
  color: #475569;
  font-size: 13px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.dark-theme .insight-stat-title {
  color: rgba(255, 255, 255, 0.72);
}

.insight-stat-value {
  font-size: 32px;
  font-weight: 850;
  color: #111827;
  line-height: 1.1;
  margin: 6px 0;
}

.dark-theme .insight-stat-value {
  color: #fff;
}

.insight-section-title {
  display: flex;
  align-items: center;
  color: #1a3483;
  font-size: 18px;
  font-weight: 800;
  margin-bottom: 14px;
}

.dark-theme .insight-section-title {
  color: #fff;
}

.insight-ai-summary {
  font-size: 15px;
  line-height: 1.7;
  background: rgba(26, 52, 131, 0.06);
  border-left: 4px solid #1a3483;
  border-radius: 12px;
  padding: 14px;
}

.dark-theme .insight-ai-summary {
  background: rgba(255, 255, 255, 0.08);
  border-left-color: #fff;
}

.insight-scroll-box {
  max-height: 360px;
  overflow-y: auto;
  padding-right: 4px;
}

.insight-scroll-box .insight-duplicate-group:last-child {
  margin-bottom: 0;
}

.insight-scroll-box thead th {
  position: sticky;
  top: 0;
  z-index: 1;
  background: #fff;
}

.dark-theme .insight-scroll-box thead th {
  background: #212529;
}

.insight-scroll-box::-webkit-scrollbar {
  width: 8px;
}
.insight-scroll-box::-webkit-scrollbar-track {
  background: transparent;
}
.insight-scroll-box::-webkit-scrollbar-thumb {
  background: rgba(148, 163, 184, 0.5);
  border-radius: 8px;
}
.dark-theme .insight-scroll-box::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.25);
}

.insight-mini-note {
  border: 1px solid rgba(148, 163, 184, 0.25);
  border-radius: 14px;
  padding: 12px;
  height: 100%;
  font-size: 14px;
}

.insight-contact-item,
.insight-duplicate-group {
  border: 1px solid rgba(148, 163, 184, 0.25);
  border-radius: 14px;
  padding: 12px;
  margin-bottom: 10px;
  background: rgba(248, 250, 252, 0.6);
}

.dark-theme .insight-contact-item,
.dark-theme .insight-duplicate-group {
  background: rgba(255, 255, 255, 0.06);
}

.insight-country-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.insight-country-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid rgba(148, 163, 184, 0.2);
  padding: 9px 0;
}

.insight-dup-person {
  font-size: 13px;
  margin-top: 7px;
  padding: 7px 9px;
  border-radius: 10px;
  background: rgba(15, 23, 42, 0.04);
}

.dark-theme .insight-dup-person {
  background: rgba(255, 255, 255, 0.08);
}

.insight-empty {
  border: 1px dashed rgba(148, 163, 184, 0.5);
  border-radius: 14px;
  padding: 22px;
  text-align: center;
  color: #475569;
}

.dark-theme .insight-empty {
  color: rgba(255, 255, 255, 0.72);
}

@media (max-width: 768px) {
  .insight-greeting {
    font-size: 24px;
  }

  .insight-header {
    align-items: stretch;
  }

  .insight-refresh-btn {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/insights.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,+BAA+B;EAC/B,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;;EAEE,SAAS;EACT,8BAA8B;EAC9B,8CAA8C;EAC9C,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kCAAkC;EAClC,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mCAAmC;EACnC,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,qCAAqC;EACrC,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;AACA;EACE,uBAAuB;AACzB;AACA;EACE,oCAAoC;EACpC,kBAAkB;AACpB;AACA;EACE,qCAAqC;AACvC;;AAEA;EACE,2CAA2C;EAC3C,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,eAAe;AACjB;;AAEA;;EAEE,2CAA2C;EAC3C,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;;EAEE,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iDAAiD;EACjD,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,2CAA2C;EAC3C,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":[".insight-header {\n  display: flex;\n  justify-content: space-between;\n  gap: 16px;\n  align-items: center;\n  margin: 8px 0 18px;\n  flex-wrap: wrap;\n}\n\n.insight-greeting {\n  font-size: 30px;\n  font-weight: 800;\n  color: #1a3483;\n  letter-spacing: -0.4px;\n}\n\n.dark-theme .insight-greeting {\n  color: #f8fafc;\n}\n\n.insight-refresh-btn {\n  background: #1a3483 !important;\n  border-color: #1a3483 !important;\n  border-radius: 999px !important;\n  padding: 9px 18px !important;\n  font-weight: 700 !important;\n}\n\n.insight-card,\n.insight-stat-card {\n  border: 0;\n  border-radius: 18px !important;\n  box-shadow: 0 12px 30px rgba(15, 23, 42, 0.08);\n  overflow: hidden;\n}\n\n.insight-stat-card .card-body {\n  position: relative;\n  min-height: 148px;\n}\n\n.insight-stat-icon {\n  width: 42px;\n  height: 42px;\n  border-radius: 14px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(26, 52, 131, 0.1);\n  color: #1a3483;\n  font-size: 22px;\n  margin-bottom: 12px;\n}\n\n.dark-theme .insight-stat-icon {\n  background: rgba(255, 255, 255, 0.12);\n  color: #fff;\n}\n\n.insight-stat-title {\n  color: #475569;\n  font-size: 13px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.dark-theme .insight-stat-title {\n  color: rgba(255, 255, 255, 0.72);\n}\n\n.insight-stat-value {\n  font-size: 32px;\n  font-weight: 850;\n  color: #111827;\n  line-height: 1.1;\n  margin: 6px 0;\n}\n\n.dark-theme .insight-stat-value {\n  color: #fff;\n}\n\n.insight-section-title {\n  display: flex;\n  align-items: center;\n  color: #1a3483;\n  font-size: 18px;\n  font-weight: 800;\n  margin-bottom: 14px;\n}\n\n.dark-theme .insight-section-title {\n  color: #fff;\n}\n\n.insight-ai-summary {\n  font-size: 15px;\n  line-height: 1.7;\n  background: rgba(26, 52, 131, 0.06);\n  border-left: 4px solid #1a3483;\n  border-radius: 12px;\n  padding: 14px;\n}\n\n.dark-theme .insight-ai-summary {\n  background: rgba(255, 255, 255, 0.08);\n  border-left-color: #fff;\n}\n\n.insight-scroll-box {\n  max-height: 360px;\n  overflow-y: auto;\n  padding-right: 4px;\n}\n\n.insight-scroll-box .insight-duplicate-group:last-child {\n  margin-bottom: 0;\n}\n\n.insight-scroll-box thead th {\n  position: sticky;\n  top: 0;\n  z-index: 1;\n  background: #fff;\n}\n\n.dark-theme .insight-scroll-box thead th {\n  background: #212529;\n}\n\n.insight-scroll-box::-webkit-scrollbar {\n  width: 8px;\n}\n.insight-scroll-box::-webkit-scrollbar-track {\n  background: transparent;\n}\n.insight-scroll-box::-webkit-scrollbar-thumb {\n  background: rgba(148, 163, 184, 0.5);\n  border-radius: 8px;\n}\n.dark-theme .insight-scroll-box::-webkit-scrollbar-thumb {\n  background: rgba(255, 255, 255, 0.25);\n}\n\n.insight-mini-note {\n  border: 1px solid rgba(148, 163, 184, 0.25);\n  border-radius: 14px;\n  padding: 12px;\n  height: 100%;\n  font-size: 14px;\n}\n\n.insight-contact-item,\n.insight-duplicate-group {\n  border: 1px solid rgba(148, 163, 184, 0.25);\n  border-radius: 14px;\n  padding: 12px;\n  margin-bottom: 10px;\n  background: rgba(248, 250, 252, 0.6);\n}\n\n.dark-theme .insight-contact-item,\n.dark-theme .insight-duplicate-group {\n  background: rgba(255, 255, 255, 0.06);\n}\n\n.insight-country-list {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.insight-country-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-bottom: 1px solid rgba(148, 163, 184, 0.2);\n  padding: 9px 0;\n}\n\n.insight-dup-person {\n  font-size: 13px;\n  margin-top: 7px;\n  padding: 7px 9px;\n  border-radius: 10px;\n  background: rgba(15, 23, 42, 0.04);\n}\n\n.dark-theme .insight-dup-person {\n  background: rgba(255, 255, 255, 0.08);\n}\n\n.insight-empty {\n  border: 1px dashed rgba(148, 163, 184, 0.5);\n  border-radius: 14px;\n  padding: 22px;\n  text-align: center;\n  color: #475569;\n}\n\n.dark-theme .insight-empty {\n  color: rgba(255, 255, 255, 0.72);\n}\n\n@media (max-width: 768px) {\n  .insight-greeting {\n    font-size: 24px;\n  }\n\n  .insight-header {\n    align-items: stretch;\n  }\n\n  .insight-refresh-btn {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
